import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getOffice',
})
export class GetOfficePipe implements PipeTransform {
  transform(id: number, source?: any[]): any {
    if (source && source.filter((item: any) => item.id.toString() === id)[0]) {
      return source.filter((item: any) => item.id?.toString() === id)[0].name;
    }
    return '';
  }
}
